import { APP_CONTEXT } from '@reducers/app/types';
import { createSlice } from '@reduxjs/toolkit';
import appTypes from '../app/types';
const createInitialCompany = () => ({
    name: '',
    domain: '',
    logoUrl: '',
    companyLid: null,
    companySearchId: '',
    isRecent: false,
    rank: 0,
});
const initialState = {
    [APP_CONTEXT.PROSPECT]: createInitialCompany(),
    [APP_CONTEXT.SEARCH]: createInitialCompany(),
};
const slice = createSlice({
    name: 'SEARCH_COMPANY',
    initialState,
    extraReducers(builder) {
        builder.addCase(appTypes.RESET, () => initialState);
    },
    reducers: {
        /** The company picked to search for, set before the employees search runs. */
        setSelectedCompany(state, { payload }) {
            var _a, _b, _c, _d, _e;
            const { company, rank = 1 } = payload;
            const searchCompany = state[payload.context];
            searchCompany.name = (_a = company.name) !== null && _a !== void 0 ? _a : '';
            searchCompany.domain = (_b = company.domain) !== null && _b !== void 0 ? _b : '';
            searchCompany.logoUrl = (_c = company.logoUrl) !== null && _c !== void 0 ? _c : '';
            searchCompany.isRecent = (_d = company.isRecent) !== null && _d !== void 0 ? _d : false;
            searchCompany.rank = rank;
            searchCompany.companySearchId = (_e = company.companySearchId) !== null && _e !== void 0 ? _e : '';
            searchCompany.companyLid = company.company_lid ? parseInt(String(company.company_lid), 10) : null;
        },
        /** Re-syncs the selection with the company the search actually resolved to. */
        setResultCompany(state, { payload }) {
            var _a;
            const searchCompany = state[payload.context];
            searchCompany.name = payload.company.name || searchCompany.name;
            searchCompany.companyLid = (_a = payload.company.company_lid) !== null && _a !== void 0 ? _a : null;
        },
        setCompanySearchId(state, { payload }) {
            state[payload.context].companySearchId = payload.companySearchId;
        },
        reset(state, { payload }) {
            state[payload.context] = createInitialCompany();
        },
    },
});
export const { reducer, actions } = slice;
export default reducer;
